import { createUnifiedTheme, palettes } from '@backstage/theme';

// R2 brand teal (from logo mark)
const R2_TEAL = '#7df3e1';
// Darker teal for light-mode filled elements (buttons/links need enough contrast for white text)
const R2_TEAL_DEEP = '#0E7C6B';

export const customLightTheme = createUnifiedTheme({
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  defaultPageTheme: 'home',
  palette: {
    ...palettes.light,
    primary: { main: R2_TEAL_DEEP },
    link: R2_TEAL_DEEP,
    linkHover: '#12B39B',
    navigation: {
      ...palettes.light.navigation,
      indicator: R2_TEAL,
      selectedColor: '#FFFFFF',
    },
    tabbar: { indicator: R2_TEAL },
  },
});

export const customDarkTheme = createUnifiedTheme({
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  defaultPageTheme: 'home',
  palette: {
    // Spread the default dark palette to keep safe background.paper (#424242),
    // status colours, banner colours, etc. — avoids the BootstrapInput black-box
    // regression caused by overriding background.paper with near-black values.
    ...palettes.dark,
    primary: { main: R2_TEAL, dark: '#5FE0CC' },
    link: R2_TEAL,
    linkHover: '#5FE0CC',
    navigation: {
      ...palettes.dark.navigation,
      indicator: R2_TEAL,
      selectedColor: '#FFFFFF',
    },
    tabbar: { indicator: R2_TEAL },
  },
});
